module.exports = __webpack_public_path__ + "img/2_2-finanziario-stazione-2.da713e42.png";